import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, get, put } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { ICompanyHeaderDisplaySettingsDTO } from './typings'

const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.companyHeaderDisplaySettings.companyHeaderDisplaySettings}`

export const getCompanyHeaderDisplaySettings = createAsyncThunk<
  ICompanyHeaderDisplaySettingsDTO,
  void,
  { rejectValue: APIError }
>('companyHeaderDisplaySettings/get', async (_, thunkApi) => {
  const response = await get(url)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const updateCompanyHeaderDisplaySettings = createAsyncThunk<
  ICompanyHeaderDisplaySettingsDTO,
  ICompanyHeaderDisplaySettingsDTO,
  { rejectValue: APIError }
>('companyHeaderDisplaySettings/update', async (input, thunkApi) => {
  const response = await put(url, input)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
